import React, {Component, Fragment} from 'react'
import moment from 'moment'
import Box from '../Layout/Box';
import SelectorInput from '../Shared/SelectorInput';

export const PasajeroEdicion = (props) => {
    const {p, i, updateInputs, handleOpenSelectorAddPasajero, displayModalAddFile, validateCaducidadPasaporte, asistencia_vajero, tipo_viaje,tipos_identificacion} = props
    const mode = p.get('pasaporte_adjunto') ? 'edit' : 'create'

    const fecha_salida = moment(p.getIn(['asistencia', 'fecha_salida']))
    const fecha_regreso = moment(p.getIn(['asistencia', 'fecha_regreso']))
    const totalDias = Math.abs(fecha_regreso.diff(fecha_salida, 'days'))

    return (
        <Fragment>

            <div className="separator"></div>

            <Box title={`Pasajero #${i + 1}`}>

                <Box title={'Información del pasajero'} onModal>

                    <div className="separator"></div>

                    <div className="row">

                        <div className="col-md-2">
                            <div className="form-group">
                                <label className="control-label">Tipo pasajero</label>
                                <select className="form-control input-sm" value={p.get('tipo_pasajero')} onChange={e => updateInputs(`solicitud.viaje.pasajeros.${i}.tipo_pasajero`, e.target.value)}>
                                    <option value="1">Empleado</option>
                                    <option value="2">Invitado</option>
                                </select>
                            </div>
                        </div>

                        {
                            (p.get('tipo_pasajero') == 1) ? (
                                <Fragment>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label className="control-label">Nombre completo</label>
                                            <SelectorInput value={p.get('fullname') ? p.get('fullname') : `${p.get('nombres') || ""} ${p.get('apellidos') || ""}`} onClick={() => handleOpenSelectorAddPasajero(`solicitud.viaje.pasajeros.${i}`)} onReset={() => updateInputs(`solicitud.viaje.pasajeros.${i}`, { selected: p.get('selected'), guid: p.get('guid') })} />
                                        </div>
                                    </div>
                                </Fragment>
                            ) : (
                                    <Fragment>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="control-label">Nombres</label>
                                                <input className="form-control input-sm" type="text" value={p.get('nombres') || ''} onChange={e => updateInputs(`solicitud.viaje.pasajeros.${i}.nombres`, e.target.value)} />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="control-label">Apellidos</label>
                                                <input className="form-control input-sm" type="text" value={p.get('apellidos') || ''} onChange={e => updateInputs(`solicitud.viaje.pasajeros.${i}.apellidos`, e.target.value)} />
                                            </div>
                                        </div>
                                    </Fragment>
                                )
                        }

                        <div className="col-md-2">
                            <div className="form-group">
                                <label className="control-label">Tipo de documento</label>
                                    <select className="form-control input-sm" value={ p.get('tipo_documento') || 1} onChange={ (e) => updateInputs(`solicitud.viaje.pasajeros.${i}.tipo_documento`, e.target.value) }>
                                        {
                                        Object.keys(tipos_identificacion).map((key, ikey) => {
                                            return (
                                                <option key={`opt[${i}][${ikey}]`} value={key}>{ tipos_identificacion[key] }</option>
                                                )
                                            })
                                        }
                                    </select>
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div className="form-group">
                                <label className="control-label">No. de Documento</label>
                                <input className="form-control input-sm" type="text" value={p.get('cedula') || ''} onChange={e => updateInputs(`solicitud.viaje.pasajeros.${i}.cedula`, e.target.value)} />
                            </div>
                        </div>
                    </div>


                    <div className="row">

                        <div className="col-md-3">
                            <div className="form-group">
                                <label className="control-label">Celular</label>
                                <input className="form-control input-sm" type="text" value={p.get('celular') || ''} onChange={e => updateInputs(`solicitud.viaje.pasajeros.${i}.celular`, e.target.value)} />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="form-group">
                                <label className="control-label">Fecha nacimiento</label>
                                <input className="form-control input-sm" type="date" value={moment(p.get('fecha_nacimiento')).format('YYYY-MM-DD') || ''} onChange={e => updateInputs(`solicitud.viaje.pasajeros.${i}.fecha_nacimiento`, e.target.value)} />
                            </div>
                        </div>


                        <div className="col-md-3">
                            <div className="form-group">
                                <label className="control-label">Correo</label>

                                {(p.get('tipo_pasajero') == 1) ? (
                                    <input className="form-control input-sm" type="text" value={p.get('correo') || ''} disabled />
                                ) : (
                                        <input className="form-control input-sm" type="text" value={p.get('correo') || ''} onChange={e => updateInputs(`solicitud.viaje.pasajeros.${i}.correo`, e.target.value)} />
                                    )}
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="form-group">
                                <label className="control-label">Nacionalidad</label>
                                <input className="form-control input-sm" type="text" value={p.get('nacionalidad') || ''} onChange={e => updateInputs(`solicitud.viaje.pasajeros.${i}.nacionalidad`, e.target.value)} disabled={tipo_viaje == 1} />
                            </div>
                        </div>

                    </div>

                    <div className="row">

                        <div className="col-md-3">
                            <div className="form-group">
                                <label className="control-label">No. Pasaporte</label>
                                <input className="form-control input-sm" type="text" value={p.get('pasaporte') || ''} onChange={e => updateInputs(`solicitud.viaje.pasajeros.${i}.pasaporte`, e.target.value)} disabled={tipo_viaje == 1} />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="form-group">
                                <label className="control-label">País expedición</label>
                                <input className="form-control input-sm" type="text" value={p.get('pais_expedicion') || ''} onChange={e => updateInputs(`solicitud.viaje.pasajeros.${i}.pais_expedicion`, e.target.value)} disabled={tipo_viaje == 1} />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="form-group">
                                <label className="control-label">Fecha caducidad pasaporte</label>
                                <input className="form-control input-sm" type="date" value={moment(p.get('fecha_caducidad_pasaporte')).format('YYYY-MM-DD') || ''} onChange={e => updateInputs(`solicitud.viaje.pasajeros.${i}.fecha_caducidad_pasaporte`, e.target.value)} onBlur={(e) => validateCaducidadPasaporte(e.target.value)} disabled={tipo_viaje == 1} />
                            </div>
                        </div>

                        <div className="col-md-3">

                            <div className="form-group">

                                <label className="control-label">
                                    Adjuntar pasaporte pasajero {i + 1}
                                </label>

                                <label className={`form-control input-sm label-upload-file ${(tipo_viaje == 2) ? 'label-upload-file-enabled' : 'label-upload-file-disabled'}`} onClick={(tipo_viaje == 2) ? () => {displayModalAddFile(true, 'Adjuntar pasaporte', mode, p.get('adjunto'), i) ; updateInputs('flagAdjunto', true);} : () => null} disabled={tipo_viaje == 1} >
                                    <i className="fa fa-upload"></i> {p.get('adjunto') ? p.getIn(['adjunto', 'nombre']) : ' Seleccione un archivo...'}
                                </label>

                            </div>
                        </div>
                    </div>
                </Box>

                {
                    (asistencia_vajero) && (
                        <Fragment>

                            <div className="separator"></div>

                            <Box title={'Información asistencia de viaje'} onModal>

                                <div className="separator"></div>

                                <div className="row">

                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label className="control-label">País destino</label>
                                            <input className="form-control input-sm" type="text" value={p.getIn(['asistencia', 'pais_destino']) || ''} onChange={e => updateInputs(`solicitud.viaje.pasajeros.${i}.asistencia.pais_destino`, e.target.value)} disabled={asistencia_vajero == false} />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label className="control-label">Fecha salida</label>
                                            <input className="form-control input-sm" type="date" value={moment(p.getIn(['asistencia', 'fecha_salida'])).format('YYYY-MM-DD') || ''} onChange={e => updateInputs(`solicitud.viaje.pasajeros.${i}.asistencia.fecha_salida`, e.target.value)} />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label className="control-label">Fecha regreso</label>
                                            <input className="form-control input-sm" type="date" value={moment(p.getIn(['asistencia', 'fecha_regreso'])).format('YYYY-MM-DD') || ''} onChange={e => updateInputs(`solicitud.viaje.pasajeros.${i}.asistencia.fecha_regreso`, e.target.value)} />
                                        </div>
                                    </div>

                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label className="control-label">Total días</label>
                                            <input className="form-control input-sm" type="text" value={totalDias || 0} disabled />
                                        </div>
                                    </div>
                                </div>
                            </Box>

                            <div className="separator"></div>

                            <Box title={'En caso de emergencia avisar a:'} onModal>

                                <div className="separator"></div>

                                <div className="row">

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label className="control-label">Nombres y apellidos</label>
                                            <input className="form-control input-sm" type="text" value={p.getIn(['asistencia', 'avisar_a']) || ''} onChange={e => updateInputs(`solicitud.viaje.pasajeros.${i}.asistencia.avisar_a`, e.target.value)} disabled={asistencia_vajero == false} />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label className="control-label">Dirección</label>
                                            <input className="form-control input-sm" type="text" value={p.getIn(['asistencia', 'direccion']) || ''} onChange={e => updateInputs(`solicitud.viaje.pasajeros.${i}.asistencia.direccion`, e.target.value)} disabled={asistencia_vajero == false} />
                                        </div>
                                    </div>

                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label className="control-label">Ciudad</label>
                                            <input className="form-control input-sm" type="text" value={p.getIn(['asistencia', 'ciudad']) || ''} onChange={e => updateInputs(`solicitud.viaje.pasajeros.${i}.asistencia.ciudad`, e.target.value)} disabled={asistencia_vajero == false} />
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label className="control-label">Celular</label>
                                            <input className="form-control input-sm" type="text" value={p.getIn(['asistencia', 'celular']) || ''} onChange={e => updateInputs(`solicitud.viaje.pasajeros.${i}.asistencia.celular`, e.target.value)} disabled={asistencia_vajero == false} />
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label className="control-label">Teléfono</label>
                                            <input className="form-control input-sm" type="text" value={p.getIn(['asistencia', 'telefono']) || ''} onChange={e => updateInputs(`solicitud.viaje.pasajeros.${i}.asistencia.telefono`, e.target.value)} disabled={asistencia_vajero == false} />
                                        </div>
                                    </div>
                                </div>
                            </Box>
                        </Fragment>
                    )
                }
            </Box>
        </Fragment>

    )
}



// WEBPACK FOOTER //
// ./src/components/TiquetesAereos/PasajeroEdicion.jsx